import { getGridDateOperators } from '@mui/x-data-grid-pro';

export const getDateOperators = () => {
	return getGridDateOperators().filter(operator => operator.value !== 'isEmpty' && operator.value !== 'isNotEmpty');
};
